<template>
  <div class="interaction">
      <div class="apparel">
        <div class="center" >
          <div class="exchange">
            <h2>Smart Wearables<br /> Data Collection</h2>
            <p>Real-time human body data collection under the<br /> collaboration of wearable devices and Al algorithms.</p>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "interaction.vue",

}
</script>

<style scoped>

.interaction {
}

.apparel {
  margin: 0 auto;
  background-image:url("../../../assets/health-img.png");
  background-repeat:no-repeat;
  background-position: right;
  height:900px;
}

.apparel .center {
  width: 1200px;
  margin: 0 auto;

}

.apparel .exchange {
  /*width:1200px;*/
  padding-top: 330px
}

 .apparel .exchange h2{
   font-style: normal;
   font-weight: 700;
   font-size: 46px;
   line-height: 80px;
}

 .apparel .exchange p{
   margin-top: 50px;
   font-style: normal;
   font-weight: 400;
   font-size: 24px;
   line-height: 50px;
   color: #999999;
 }

</style>
